import sanitize from 'sanitize-filename';
import { saveAs } from 'file-saver';
import { AES, SHA256, enc } from 'crypto-js';
// import { Base64 } from 'js-base64';
import { compressToBase64, decompressFromBase64 } from 'lz-string';

import { FILE_EXTENSION } from '../constants/globals';

export const download = (filename, data) => {
  const name = sanitize(filename.replace(/\s/g, '')) + FILE_EXTENSION;
  const content = createFileContent(data);
  const blob = new Blob([content], { type: 'application/x-stackup' });
  saveAs(blob, name);
}

const createFileContent = (data, secret = '') => {
  const header = compressToBase64(JSON.stringify({
    createdOn: window.location.hostname,
    createdAt: new Date(),
    createdBy: null,
    needSecret: secret !== '',
    encryptAlg: 'AES'
  }));
  const json = JSON.stringify(data);
  const body = compressToBase64(AES.encrypt(JSON.stringify(data), secret).toString());
  const checksum = SHA256(json);

  return `${header}.${body}.${checksum}`;
}

export const readFile = (file, secret = '') => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = function(event) {
      const result = event.target.result;
      const [header, body, checksum] = result.split('.');

      try {
        const bodyJson = AES.decrypt(decompressFromBase64(body), secret).toString(enc.Utf8);
        const headerJson = decompressFromBase64(header);
        const validate = SHA256(bodyJson).toString();

        if (checksum === validate) {
          const bodyData = JSON.parse(bodyJson);
          const headData = JSON.parse(headerJson);
          resolve({ header: headData, body: bodyData });
        } else {
          reject(new Error('The file seems to be corrupted: Checksum Validation Failed'));
        }
      } catch (err) {
        reject(err);
      }
    }
    reader.readAsText(file);
  });
}

export default { download }


// WEBPACK FOOTER //
// ./src/lib/file.js